// UserSelector.jsx
import React, { useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import CreateUser from "./createUser";
import ExistingUser from "./ExistingUser";

const UserSelector = () => {
  const [selectedOption, setSelectedOption] = useState("new");

  return (
    <div style={{ padding: "0px" }}>
      <FormControl component="fieldset">
        <RadioGroup
          row
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <FormControlLabel
            value="new"
            control={<Radio size="small" />}
            label="New"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          />
          <FormControlLabel
            value="existing"
            control={<Radio size="small" />}
            label="Existing"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          />
        </RadioGroup>
      </FormControl>

      <div style={{ marginTop: "20px" }}>
        {selectedOption === "new" ? <CreateUser /> : <ExistingUser />}
      </div>
    </div>
  );
};

export default UserSelector;
